var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "49555AD6-4FA0-4DB5-9BC9-F083DA3119EC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "V1-hp-Copy",
    transform: "translate(-93.000000, -787.000000)",
    fill: "#9EA718",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MENU",
    transform: "translate(0.000000, 725.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.262787,62.2928029 C105.830219,61.902399 105.172464,61.902399 104.739896,62.2928029 L93.3750403,72.5495855 C93.1369699,72.7644485 93.000758,73.0698934 93,73.3905849 L93,85.8635144 C93,86.4911781 93.5088219,87 94.1364856,87 L102.091885,87 C102.719549,87 103.22837,86.4911781 103.22837,85.8635144 L103.22837,80.1810864 L107.774313,80.1810864 L107.774313,85.8635144 C107.774313,86.4911781 108.283135,87 108.910798,87 L116.866198,87 C117.493861,87 118.002683,86.4911781 118.002683,85.8635144 L118.002683,73.3905849 C118.001925,73.0698934 117.865713,72.7644485 117.627643,72.5495855 L106.262787,62.2928029 Z",
    id: "Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeGreen);
export default __webpack_public_path__ + "static/media/home-green.5cc1258492da41e82d255c7c479866fb.svg";
export { ForwardRef as ReactComponent };